import styled from "styled-components";
import healthExIllustrationImage2 from "../Media/HealthEx-illustration-2.png";
import healthExIllustrationImage3 from "../Media/HealthEx-illustration-3.png";
import researcherInvalidInvitation from "../Media/ResearcherInvalidInvitation.png";
import { fontSizes } from "healthex-common/sizes";
import { FlexColumnDiv } from "./common.styles";
export const InvalidInvitationImage = styled.div `
    background-image: url(${healthExIllustrationImage3});
    background-repeat: no-repeat;
    height: 400px;
    width: 500px;
    flex-grow: 1;
`;
export const ResearcherInvalidInvitationImage = styled.div `
    background-image: url(${researcherInvalidInvitation});
    background-repeat: no-repeat;
    background-size: contain;
    height: 400px;
    width: 400px;
    flex-grow: 1;
`;
export const UserWelcomeLinkImage = styled.div `
    background-image: url(${healthExIllustrationImage2});
    background-repeat: no-repeat;
    height: 400px;
    width: 400px;
    flex-grow: 1;
`;
export const HelpContainer = styled(FlexColumnDiv) `
    align-items: center;
    gap: 16px;
`;
export const HelpText = styled.div `
    font-size: ${fontSizes.TINY};
    letter-spacing: 0.4px;
`;
